//./src/pages/auth.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";
import { sendCode, registerUser, getGoogleAuthUrl } from "../services/auth";
import "../styles/auth.css";

const AuthPage = ({ onRegisterSuccess }) => {
    const [form, setForm] = useState({
        name: "",
        email: "",
        descriptions: "",
        password: "",
        code: "",
        service_ids: [],
    });
    const [message, setMessage] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [step, setStep] = useState("email");
    const navigate = useNavigate();

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSendCode = async () => {
        try {
            const { ok, data } = await sendCode(form.email);
            if (ok) {
                setMessage("📨 Код підтвердження надіслано на email");
                setStep("code");
            } else {
                setMessage("❌ Помилка: " + (data.detail || "Невідома помилка"));
            }
        } catch (error) {
            setMessage("❌ Помилка з'єднання: " + error.message);
        }
    };

    const handleRegister = async () => {
        try {
            const { ok, data } = await registerUser(form);

            if (ok) {
                setMessage("✅ Реєстрація успішна. Тепер увійдіть.");

                if (typeof onRegisterSuccess === 'function') {
                    onRegisterSuccess();
                }
                navigate("/");
            } else {
                setMessage("❌ " + (data.detail || "Помилка реєстрації"));
            }
        } catch (error) {
            setMessage("❌ Помилка: " + error.message);
        }
    };

    const handleGoogleRegister = () => {
        window.location.href = getGoogleAuthUrl();
    };

    return (
        <div className="auth-container">
            <div className="auth-form">
                <h2 className="form-title">Реєстрація</h2>

                <>
                    <h4>Швидка реєстрація через Google</h4>
                    <button
                        onClick={handleGoogleRegister}
                        className="action-btn google-register-btn"
                    >
                        Продовжити з Google
                    </button>
                    <hr className="divider" />
                </>

                <div className="form-inputs">
                    {step === "email" && (
                        <>
                            <input
                                type="email"
                                name="email"
                                placeholder="Email"
                                value={form.email}
                                onChange={handleChange}
                                className="input-field"
                                required
                            />
                            <button
                                onClick={handleSendCode}
                                className="action-btn send-code-btn"
                                disabled={!form.email}
                            >
                                Надіслати код підтвердження
                            </button>
                        </>
                    )}

                    {step === "code" && (
                        <>
                            <input
                                type="text"
                                name="name"
                                placeholder="Ім'я"
                                value={form.name}
                                onChange={handleChange}
                                className="input-field"
                                required
                            />
                            <input
                                type="text"
                                name="descriptions"
                                placeholder="Опис (наприклад, адреса)"
                                value={form.descriptions}
                                onChange={handleChange}
                                className="input-field"
                            />
                            <div className="password-field">
                                <input
                                    type={showPassword ? "text" : "password"}
                                    name="password"
                                    placeholder="Пароль"
                                    value={form.password}
                                    onChange={handleChange}
                                    className="input-field"
                                    required
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowPassword(!showPassword)}
                                    className="password-toggle-btn"
                                >
                                    {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                                </button>
                            </div>
                            <input
                                type="text"
                                name="code"
                                placeholder="Код підтвердження з email"
                                value={form.code}
                                onChange={handleChange}
                                className="input-field"
                                required
                            />
                            <button
                                onClick={handleRegister}
                                className="action-btn register-btn"
                                disabled={!form.code || !form.password || !form.name}
                            >
                                Завершити реєстрацію
                            </button>
                        </>
                    )}

                    <button
                        onClick={() => navigate("/")}
                        className="action-btn back-btn"
                    >
                        Назад
                    </button>

                    {message && <p className="message">{message}</p>}
                </div>
            </div>
        </div>
    );
};

export default AuthPage;
